
import app from "../../variocube.carrier/src";
export default app;

